import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.flaskdata.io',
    headers: {
        'Content-Type': 'application/json',
        //'Access-Control-Expose-Headers': 'X-Auth'
    }
});